import type { GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccount200 } from '@fukuri-admins/apis/client/gen/model';

type Args = {
  /** API レスポンス全体。null = 未連携（404） */
  data: GetApiV1ThreeLetterCodePartnerAdminsUsersUserIdBankAccount200 | null;
};

type IConvertToBankAccountDisplayFields = (args: Args) => {
  /**
   * 店番（例: `021`）。未連携または branch_number が null の場合は '-' を返す。
   */
  branchCode: string;
  /**
   * 口座番号（マスク表示: `••••••••{last4}` 形式）。
   * 未連携の場合は '-' を返す。
   */
  accountNumber: string;
};

/**
 * 口座情報を利用者編集フォームの表示フィールド値に変換する。
 *
 * - 単一取得 API（GET /partner_admins/users/:user_id/bank_account）のレスポンス全体を入力とする
 * - data が null（未連携: 404）の場合は branchCode / accountNumber ともに '-' を返す
 * - 店番（branch_number）は実データを表示する（null の場合は '-'）
 *
 * @param data - API レスポンス全体（null = 未連携: 404）
 * @returns 表示用の branchCode / accountNumber
 */
export const convertToBankAccountDisplayFields: IConvertToBankAccountDisplayFields = ({
  data,
}) => ({
  // branch_number は openapi.yml で required かつ nullable だが、
  // Orval 生成型に含まれていないため ?? でフォールバックする（UserListBankAccount の converter と同じ扱い）
  branchCode: data?.bank_account.branch_number ?? '-',
  accountNumber: data?.bank_account.account_number_last4
    ? `••••••••${data.bank_account.account_number_last4}`
    : '-',
});
